import {brand, Branded, TypeOf} from 'io-ts';
import isISO31661Alpha2 from 'validator/lib/isISO31661Alpha2';
import {NonEmptyString} from './NonEmptyString';

interface CountryCodeAlpha2Brand {
    readonly CountryCodeAlpha2: unique symbol;
}
export const CountryCodeAlpha2 = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, CountryCodeAlpha2Brand> => isISO31661Alpha2(n),
    'CountryCodeAlpha2'
);
export type CountryCodeAlpha2 = TypeOf<typeof CountryCodeAlpha2>;
